import React, { Fragment, PureComponent } from "react";
import { Header, Grid, Button, Divider, Menu, Checkbox, Input, Dropdown, Icon, Label } from "semantic-ui-react";
import isEmpty from "lodash/isEmpty";
export class ProductBundles extends PureComponent {
  state = { currentBundle: null, addNewBundle: false };

  componentDidMount() {
    this.setState({ initialTieredBundles: this.props.tieredBundles });
  }

  toggleBundle = () => {
    const { bundleOptions } = this.props;

    this.setState({
      currentBundle: {
        bundleSlug: bundleOptions[0].value,
        size: "",
        term: "monthly",
        visible: true
      },
      addNewBundle: true
    });
  };

  preventSubmit = e => {
    if (e.key === "Enter") e.preventDefault();
  };

  resetBundle = () => {
    this.setState({ currentBundle: null });
  };

  handleBundlesChange = (e, data) => {
    const { name, value } = data;

    name === "visible"
      ? this.setState((prevState, props) => ({
          currentBundle: { ...prevState.currentBundle, visible: !prevState.currentBundle.visible }
        }))
      : this.setState((prevState, props) => ({ currentBundle: { ...prevState.currentBundle, [name]: value } }));
  };

  handleAddProductBundle = () => {
    this.setState({ currentBundle: null, addNewBundle: false });
    this.props.onItemAdd({ ...this.state.currentBundle });
  };

  validateSize = (e, data) => {
    const { value } = data;
    const { addNewBundle } = this.state;
    const { isTemplateSelected, updateTemplateBundleInput, updateExtraBundleInput, templatesBundles } = this.props;
    const newTemplateBundle = templatesBundles?.find(templatesBundle => templatesBundle.bundleSlug === data.name);

    if (isNaN(value) || value < 0) {
      this.setState({ error: "Size must be a positive number" });
    } else {
      if (isTemplateSelected && !addNewBundle && !isEmpty(newTemplateBundle)) {
        updateTemplateBundleInput(e, data);
      } else if (isTemplateSelected && isEmpty(newTemplateBundle) && !addNewBundle) {
        updateExtraBundleInput(e, data);
      } else {
        this.handleBundlesChange(e, data);
        this.setState({ error: null });
      }
    }
  };

  handleBlur = e => {
    if (e.currentTarget.value === "") {
      this.setState({ error: "Size is required" });
    } else {
      this.setState({ error: null });
    }
  };

  isExistsInTemplatesBundles = (productBundle, templatesBundles) => {
    const productBundleInTemplate = templatesBundles.filter(
      templatesBundle => templatesBundle.bundleSlug === productBundle.bundleSlug
    );

    return !isEmpty(productBundleInTemplate);
  };

  existingBundle = (item, productBundles) => {
    if (isEmpty(productBundles)) return false;
    if (this[item.bundleSlug] !== undefined) return this[item.bundleSlug];

    const existingProductBundle = productBundles.filter(productBundle => productBundle.bundleSlug === item.bundleSlug);
    if (isEmpty(existingProductBundle)) return [];

    this[existingProductBundle[0].bundleSlug] = {
      slug: existingProductBundle[0].bundleSlug,
      size: existingProductBundle[0].size,
      term: existingProductBundle[0].term,
      visible: existingProductBundle[0].visible
    };
    return this[existingProductBundle[0].bundleSlug];
  };

  render() {
    const {
      productBundles,
      bundleOptions,
      bundles,
      productTemplateAssigned,
      isTemplateSelected,
      templatesBundles,
      tieredBundles
    } = this.props;
    const { currentBundle, error, initialTieredBundles, addNewBundle } = this.state;
    const templateApplied = productTemplateAssigned || isTemplateSelected;
    const noOfColumnsWithTemplate = templateApplied ? 6 : 5;
    const sizeColumnWidth = templateApplied ? 3 : 4;
    const termColumnWidth = templateApplied ? 2 : 3;
    const visibleColumnWidth = templateApplied ? 3 : 2;
    const recycleBinColumnWidth = templateApplied ? 1 : 3;

    return (
      <Fragment>
        <Header>Bundles</Header>
        <Grid textAlign="left">
          <Grid.Row columns={noOfColumnsWithTemplate}>
            <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4}>
              Name
            </Grid.Column>
            <Grid.Column width={sizeColumnWidth} textAlign="left">
              Size
            </Grid.Column>
            <Grid.Column width={termColumnWidth} textAlign="left">
              Term
            </Grid.Column>
            <Grid.Column width={visibleColumnWidth} textAlign="center">
              Visible
            </Grid.Column>
            {templateApplied && (
              <Grid.Column widescreen={3} largeScreen={3} tablet={3} mobile={3} textAlign="center">
                Tiered
              </Grid.Column>
            )}
            <Grid.Column width={recycleBinColumnWidth} />
          </Grid.Row>
          <Divider />
          {!isTemplateSelected &&
            productBundles &&
            productBundles.map((item, idx) => {
              const disableDestroyButton = !(!isEmpty(item.links?.destroy) || isEmpty(item.id) || !productTemplateAssigned);
              return (
                !item.removed && (
                  <Grid.Row columns={noOfColumnsWithTemplate} key={idx} data-test="bundleRow">
                    <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} className="break-word">
                      {bundles.find(bundle => {
                        return bundle.id === item.bundleSlug;
                      }).name + ` (${item.bundleSlug})`}
                    </Grid.Column>
                    <Grid.Column width={sizeColumnWidth} textAlign="left">
                      {item.size}
                    </Grid.Column>
                    <Grid.Column width={termColumnWidth} textAlign="left">
                      {item.term}
                    </Grid.Column>
                    <Grid.Column width={visibleColumnWidth} textAlign="center">
                      <Checkbox
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("bundle", item.id, data)}
                        disabled={disableDestroyButton}
                      />
                    </Grid.Column>
                    {templateApplied && (
                      <Grid.Column width={3} textAlign="center">
                        <Checkbox name="tiered" checked={tieredBundles.includes(item.bundleSlug)} disabled />
                      </Grid.Column>
                    )}
                    <Grid.Column width={recycleBinColumnWidth} textAlign="right">
                      <Icon
                        name="trash alternate"
                        color="orange"
                        link
                        onClick={this.props.onItemRemove(idx)}
                        disabled={disableDestroyButton}
                      />
                    </Grid.Column>
                  </Grid.Row>
                )
              );
            })}

          {isTemplateSelected &&
            productBundles &&
            productBundles.map((item, idx) => {
              if (!this.isExistsInTemplatesBundles(item, templatesBundles) && item.removed === true)
                return (
                  <Grid.Row columns={6} className="diff-red" key={idx}>
                    <Grid.Column width={4} className="break-word">
                      {bundles.find(bundle => {
                        return bundle.id === item.bundleSlug;
                      }).name + ` (${item.bundleSlug})`}
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="left">
                      {item.size}
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="left">
                      {item.term}
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="center">
                      <Checkbox
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("bundle", item.id, data)}
                        disabled={true}
                      />
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="center">
                      <Checkbox name="tiered" checked={tieredBundles.includes(item.bundleSlug)} disabled />
                    </Grid.Column>
                    <Grid.Column width={1} textAlign="right">
                      <Icon name="add alternate" link color="yellow" onClick={this.props.onItemAddedAgain(idx)} />
                      <Icon
                        name="trash alternate"
                        link
                        color={"yellow"}
                        onClick={this.props.onItemRemove(idx)}
                        disabled={true}
                        data-test="deleteBundle"
                      />
                    </Grid.Column>
                  </Grid.Row>
                );
              if (!this.isExistsInTemplatesBundles(item, templatesBundles)) {
                return (
                  <Grid.Row columns={6} key={idx}>
                    <Grid.Column width={4} className="break-word">
                      {bundles.find(bundle => {
                        return bundle.id === item.bundleSlug;
                      }).name + ` (${item.bundleSlug})`}
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="left">
                      <Input
                        size="small"
                        placeholder="Enter size"
                        name={item.bundleSlug}
                        value={item.size}
                        id={idx}
                        onChange={this.validateSize}
                        onBlur={this.handleBlur}
                        onKeyPress={this.preventSubmit}
                      />
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="left">
                      {item.term}
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="center">
                      <Checkbox
                        name="visible"
                        checked={item.visible}
                        onChange={(e, data) => this.props.onItemUpdate("bundle", item.id, data)}
                      />
                    </Grid.Column>
                    <Grid.Column width={3} textAlign="center">
                      <Checkbox name="tiered" checked={tieredBundles.includes(item.bundleSlug)} disabled />
                    </Grid.Column>
                    <Grid.Column width={1} textAlign="right">
                      <Icon
                        name="trash alternate"
                        link
                        color={"yellow"}
                        onClick={this.props.onItemRemove(idx)}
                        data-test="deleteBundle"
                      />
                    </Grid.Column>
                  </Grid.Row>
                );
              }
            })}

          {isTemplateSelected &&
            templatesBundles &&
            templatesBundles.map((item, idx) => (
              <Grid.Row columns={6} className="diff-green" key={idx}>
                <Grid.Column width={4} className="break-word">
                  {bundles.find(bundle => {
                    return bundle.id === item.bundleSlug;
                  }).name + ` (${item.bundleSlug})`}
                </Grid.Column>
                <Grid.Column width={3} textAlign="left">
                  <Input
                    size="small"
                    placeholder="Enter size"
                    name={item.bundleSlug}
                    value={item.size}
                    onChange={this.validateSize}
                    onBlur={this.handleBlur}
                    onKeyPress={this.preventSubmit}
                  />
                  {!isEmpty(this.existingBundle(item, productBundles)) && this[item.bundleSlug].size !== item.size && (
                    <Grid>
                      <Grid.Row columns={1}>
                        <Grid.Column>
                          <Label basic color="red" pointing>
                            Was {this[item.bundleSlug].size}
                          </Label>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )}
                </Grid.Column>
                <Grid.Column width={2} textAlign="left">
                  {item.term}
                  {!isEmpty(this.existingBundle(item, productBundles)) && this[item.bundleSlug].term !== item.term && (
                    <Grid>
                      <Grid.Row columns={1}>
                        <Grid.Column>
                          <Label basic color="red" pointing>
                            Was {this[item.bundleSlug].term}
                          </Label>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )}
                </Grid.Column>
                <Grid.Column width={3} textAlign="center">
                  <Checkbox
                    disabled={true}
                    name="visible"
                    checked={item.visible}
                    onChange={(e, data) => this.props.onItemUpdate("bundle", item.id, data)}
                  />
                  {!isEmpty(this.existingBundle(item, productBundles)) && this[item.bundleSlug].visible !== item.visible && (
                    <Grid>
                      <Grid.Row columns={1}>
                        <Grid.Column>
                          <Label basic color="red" pointing>
                            Was{" "}
                            <Checkbox
                              disabled={true}
                              name="oldVisible"
                              data-test="oldVisible"
                              checked={this[item.bundleSlug].visible}
                            />
                          </Label>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )}
                </Grid.Column>
                <Grid.Column width={3} textAlign="center">
                  <Checkbox name="tiered" checked={tieredBundles.includes(item.bundleSlug)} disabled />
                  {!isEmpty(initialTieredBundles) &&
                    initialTieredBundles.includes(item.bundleSlug) !== tieredBundles.includes(item.bundleSlug) && (
                      <Grid>
                        <Grid.Row columns={1}>
                          <Grid.Column>
                            <Label basic color="red" pointing>
                              Was{" "}
                              <Checkbox
                                disabled={true}
                                name="oldTiered"
                                data-test="oldTiered"
                                checked={initialTieredBundles.includes(item.bundleSlug)}
                              />
                            </Label>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    )}
                </Grid.Column>
                <Grid.Column width={1} textAlign="right">
                  <Icon
                    name="trash alternate"
                    link
                    color={"orange"}
                    onClick={this.props.onItemRemove(idx)}
                    disabled={true}
                  />
                </Grid.Column>
              </Grid.Row>
            ))}
        </Grid>

        {currentBundle && addNewBundle ? (
          <Grid textAlign="left">
            <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4}>
              <Dropdown
                fluid
                name="bundleSlug"
                data-test="productBundlesOptions"
                selection
                options={bundleOptions}
                value={currentBundle.bundleSlug}
                onChange={this.handleBundlesChange}
              />
            </Grid.Column>
            <Grid.Column widescreen={4} largeScreen={4} tablet={4} mobile={4} textAlign="left">
              <Input
                placeholder="Enter size"
                name="size"
                value={currentBundle.size}
                onChange={this.validateSize}
                onBlur={this.handleBlur}
                onKeyPress={this.preventSubmit}
              />
              {error && (
                <Label basic color="red" pointing>
                  {error}
                </Label>
              )}
            </Grid.Column>
            <Grid.Column widescreen={3} largeScreen={3} tablet={3} mobile={3} textAlign="left">
              <Checkbox
                radio
                className="mr-10"
                label="Monthly"
                name="term"
                value="monthly"
                data-test="monthlyBundle"
                checked={currentBundle.term === "monthly"}
                onChange={this.handleBundlesChange}
              />
              <Checkbox
                radio
                label="Yearly"
                name="term"
                value="yearly"
                data-test="yearlyBundle"
                checked={currentBundle.term === "yearly"}
                onChange={this.handleBundlesChange}
              />
            </Grid.Column>
            <Grid.Column widescreen={2} largeScreen={2} tablet={2} mobile={2} textAlign="center">
              <Checkbox
                name="visible"
                checked={currentBundle.visible}
                onChange={this.handleBundlesChange}
                data-test="bundleVisible"
              />
            </Grid.Column>
            <Grid.Column widescreen={3} largeScreen={3} tablet={3} mobile={3} textAlign="right">
              <Button
                size="mini"
                color="orange"
                content="Add"
                data-test="addBundle"
                onClick={this.handleAddProductBundle}
                disabled={!!error || !currentBundle.size}
              />
              <Button
                size="mini"
                style={{
                  backgroundColor: "#fff",
                  color: "orange"
                }}
                content="Cancel"
                data-test="cancelBundle"
                onClick={this.resetBundle}
              />
            </Grid.Column>
          </Grid>
        ) : (
          <Menu size="small" borderless secondary>
            <Menu.Item
              disabled={isEmpty(bundleOptions)}
              header
              link
              icon="add"
              content="Add New Bundle"
              onClick={this.toggleBundle}
              className="text orange"
              data-test="plusBundleOption"
            />
          </Menu>
        )}
      </Fragment>
    );
  }
}

export default ProductBundles;
